<template>
    <div class="xyz">
        <md-table md-height="80%" v-model="searched" md-sort="branch" md-sort-order="desc" md-card md-fixed-header>
            <md-table-toolbar>
                <div class="md-toolbar-section-start">
                    <h1 class="md-title">Branches</h1>
                </div>

                <md-field md-clearable class="md-toolbar-section-end">
                    <md-input placeholder="Search by name..." v-model="search" @input="searchOnTable" />
                </md-field>
            </md-table-toolbar>

            <md-table-empty-state
                    md-label="No jobs found"
                    :md-description="`No branch found for this '${search}' query. Try a different search term.`">
            </md-table-empty-state>

            <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single" v-bind:id="item.branch_name.replace(/origin\//g,'')">
                <md-table-cell md-label="ID" md-sort-by="id">
                    <router-link :to="{path: '/jobshash?dateName='+dateJob, hash: item.branch_name.replace(/origin\//g,'')}">{{ item.id }}</router-link>
                </md-table-cell>
                <md-table-cell md-label="Date">{{ dateJob || '-' }}</md-table-cell>
                <md-table-cell md-label="Branch" md-sort-by="branch_name">{{ item.branch_name.replace('origin/'+dateJob+'-','') || '-' }}</md-table-cell>
                <md-table-cell md-label="Status" md-sort-by="combined_state">{{ item.combined_state || '-' }}</md-table-cell>
                <md-table-cell md-label="Check Runs URL">
                    <div v-for="(f, i) in item.check_runs_urls" :key="i">
                        {{ item.check_runs_urls.length - i }} -
                        <a target="_blank" :href="f" icon="icon-download" type="primary">
                            {{ f }}
                        </a>
                        <pre></pre>
                    </div>
                </md-table-cell>
                <md-table-cell md-label="Runs URL">
                    <div v-for="(f, i) in item.check_runs_details_urls" :key="i">
                        {{ item.check_runs_details_urls.length - i }} -
                        <a target="_blank" :href="f" icon="icon-download" type="primary">
                            {{ f }}
                        </a>
                        <pre></pre>
                    </div>
                </md-table-cell>
                <md-table-cell md-label="Annotation">
                    <div v-for="(f, i) in item.annotations_output" :key="i">
                        {{ item.annotations_output.length - i }}: Title: {{ f.title }}<br />
                        {{ item.annotations_output.length - i }}: Summary: {{ f.summary }}
                        <pre></pre>
                    </div>
                </md-table-cell>
                <md-table-cell md-label="Log Detail" v-if="item.combined_state!='success'">
                    <div v-for="(f, i) in item.timeline_logs" :key="i">
                        {{ item.timeline_logs.length - i }}: + Detail:
                        <a target="_blank" :href="f.url" icon="icon-download" type="primary">
                            {{ f.url }}
                        </a><br />
                        {{ item.timeline_logs.length - i }}: Type: {{ f.type }}<br />
                        {{ item.timeline_logs.length - i }}: Name: {{ f.name }}<br />
                        {{ item.timeline_logs.length - i }}: Result: {{ f.result }}<br />
                        {{ item.timeline_logs.length - i }}: Detail:
                        <div v-for="(g, j) in f.error" :key="j">
                            {{item.timeline_logs.length - i}}.{{j+1}}.- {{ g.substring(0, 200) }}...<br />
                            ---------------------------------------------
                        </div>
                        <pre></pre>
                    </div>
                    <div v-for="(f, i) in item.run_action_logs" :key="i">
                        {{ item.run_action_logs.length - i }} -
                        +Detail: <a target="_blank" :href="f" icon="icon-download" type="primary">
                            {{ f }}
                        </a>
                        <pre></pre>
                    </div>
                </md-table-cell>
                <md-table-cell md-label="Log Detail" v-else>-</md-table-cell>
                <md-table-cell md-label="Time" md-sort-by="time">
                    <div v-for="(f, i) in item.elapsed_time" :key="i">
                        {{ item.elapsed_time.length - i }} - {{ f }}
                        <pre></pre>
                    </div>
                </md-table-cell>
            </md-table-row>
        </md-table>
    </div>
</template>

    <script>
        import gql from 'graphql-tag'
        import { db }  from "../firebaseconfig.js"
        import { ref, query, orderByKey, equalTo, onValue } from "firebase/database";
        const toLower = text => {
            return text.toString().toLowerCase()
        }

        const searchByName = (items, term) => {
            //TBD: review find key on nodes graphql
            if (term) {
                return items.filter(item => toLower(item.branch_name).includes(toLower(term)))
            }
            return items
        }

        // const maxSizeOfJobs = 30

        export const LIST_JOB_PER_NIGHTLY = gql`
            query($dateNameForNightlyJob:String!){
                  repository(name: "crossbow", owner: "ursacomputing") {
                    refs(first: 100, refPrefix: "refs/heads/", query: $dateNameForNightlyJob) {
                      pageInfo {
                        hasNextPage
                      }
                      edges {
                        node {
                          name
                        }
                      }
                      totalCount
                    }
                  }
              }
            `

        export default {
            name: "ListStatusPerJob",
            data: () => (
                {
                    selected: [],
                    search: null,
                    searched: [],
                    listJobs: [],
                    logMessageUrl: '',
                    counter: 0,
                    dateJob: null,
                }
            ),
            methods: {
                displayCheckRunLink(urlLinks){
                    for(const url of urlLinks){
                        if (urlLinks.length > 1){
                            console.log(url);
                        }
                    }
                },
                searchOnTable () {
                    this.searched = searchByName(this.listJobs, this.search)
                },
                getListJobPerNightlyDay(){
                    //1st: Get day for nightly job
                    // this.dateJob = this.$route.params.dateName;
                    this.dateJob = this.$route.query.dateName;
                    console.log('1st phase: Get day for nightly job');
                    console.log('day is: ' + this.dateJob);

                    //2nd: Get list of branches
                    console.log('2nd phase: Get list of branches');
                    var dbRef = ref(db, '/arrow');

                    const dataPerNightlyJobDay = query(dbRef, orderByKey(), equalTo(this.dateJob));

                    onValue(dataPerNightlyJobDay, (snapshot) => {
                        snapshot.forEach((childSnapshot) => {
                            const childKey = childSnapshot.key;
                            const childData = childSnapshot.val();
                            // this.listJobs = childData.data;

                            //order by failed

                            this.listJobs = childData.data.sort((a, b) => Number(a.id) - Number(b.id));


                            console.log(childKey);
                            console.log(childData);
                            this.searched = this.listJobs
                        });
                    }, {
                        onlyOnce: true
                    });
                },
            },
            created() {
                this.getListJobPerNightlyDay();

            },
            updated() {
                this.$nextTick(() => {
                    if(this.$route.hash) {
                        const el = document.querySelector(this.$route.hash);
                        el && el.scrollIntoView();
                    }
                })
            }
        }
</script>

<style lang="scss" scoped>
</style>
